(function($, app, mtl, util, svg4everybody) {
	'use strict';

	// Disable animations while resizing the window
	var enableAnimationsAfterDelay = util.debounce(app.animations.enable, 200);
	$(window).on('resize orientationchange', function() {
		app.animations.disable();
		enableAnimationsAfterDelay();
	});

	// Initiate alloy process on document.ready
	$(document).ready(function() {
		mtl.alloy.process(document.body);
		enableAnimationsAfterDelay();

		// Polyfill external <use> support for IE
		svg4everybody();
	});

}($, app, mtl, util, svg4everybody));
